/* eslint-disable max-lines */
import { all, call, put } from 'redux-saga/effects'

import routes, { Router } from '../../routes'
import i18n from '../../i18n'
import { app } from '../../configuration'
import { actions as appActions } from '../../redux/app/redux'


export default class ApplicationBackgroundSagas {

  static* init() {
    return yield call(ApplicationBackgroundSagas.setupSeo)
  }

  static* setupSeo() {
    yield put(
      appActions.setSeo({
        title: i18n.t('SEO_applicationBackground_title'),
        description: i18n.t('SEO_applicationBackground_description'),
        keywords: i18n.t('SEO_applicationBackground_keywords'),
        url: `${app.APP_URL}${Router.getRouteUrl(routes.applicationBackground)}`,
        noindex: false,
      })
    )
  }

  static* loop() {
    yield all([
      //
    ])
  }

}
